// ABOUTME: Manages the engraving modal for a product page block.
// ABOUTME: Handles open/close, character counting, font selection, localStorage persistence, and hidden input sync.

class ProductEngraving {
  #root;
  #productId;
  #dialog;
  #triggerButton;
  #summary;
  #summaryText;
  #textInput;
  #charCounter;
  #saveButton;
  #removeLink;
  #closeButton;
  #textHiddenInput;
  #fontHiddenInput;
  #textPrivateHiddenInput;
  #fontPrivateHiddenInput;

  constructor(root) {
    this.#root = root;
    this.#productId = root.dataset.productId;

    const textInputId = root.dataset.textInputId;
    const fontInputId = root.dataset.fontInputId;
    const textPrivateInputId = root.dataset.textPrivateInputId;
    const fontPrivateInputId = root.dataset.fontPrivateInputId;
    const dialogId = root.dataset.dialogId;

    this.#dialog = document.getElementById(dialogId);
    this.#triggerButton = root.querySelector('.product-engraving__button');
    this.#summary = root.querySelector('.product-engraving__summary');
    this.#summaryText = root.querySelector('.product-engraving__summary-text');
    this.#textInput = root.querySelector('.product-engraving__input');
    this.#charCounter = root.querySelector('.product-engraving__char-counter');
    this.#saveButton = root.querySelector('.product-engraving__save-button');
    this.#removeLink = root.querySelector('.product-engraving__remove-link');
    this.#closeButton = root.querySelector('.product-engraving__dialog-close');
    this.#textHiddenInput = document.getElementById(textInputId);
    this.#fontHiddenInput = document.getElementById(fontInputId);
    this.#textPrivateHiddenInput = document.getElementById(textPrivateInputId);
    this.#fontPrivateHiddenInput = document.getElementById(fontPrivateInputId);

    this.#triggerButton.addEventListener('click', () => this.#open());
    this.#summary.addEventListener('click', () => this.#open());
    this.#closeButton.addEventListener('click', () => this.#close());
    this.#dialog.addEventListener('cancel', () => this.#close());
    this.#dialog.addEventListener('click', (event) => {
      if (event.target === this.#dialog) {
        this.#close();
      }
    });
    this.#textInput.addEventListener('input', () => this.#updateCounter());
    this.#saveButton.addEventListener('click', () => this.#save());

    if (this.#removeLink) {
      this.#removeLink.addEventListener('click', () => this.#remove());
    }

    this.#initFromStorage();
  }

  #open() {
    this.#prefillFromStorage();
    this.#updateCounter();
    this.#dialog.showModal();
    this.#textInput.focus();
  }

  #close() {
    this.#dialog.close();
  }

  #updateCounter() {
    const length = this.#textInput.value.length;
    const max = this.#textInput.maxLength;

    this.#charCounter.textContent = `${length}/${max}`;
    this.#saveButton.disabled = this.#textInput.value.trim().length === 0;
  }

  #writeHiddenInputs(text, font) {
    this.#textHiddenInput.value = text;
    this.#textPrivateHiddenInput.value = text;
    this.#fontHiddenInput.value = font;
    this.#fontPrivateHiddenInput.value = font;
  }

  #save() {
    const text = this.#textInput.value.trim();
    const font = this.#getSelectedFont();

    this.#writeHiddenInputs(text, font);

    localStorage.setItem(`engraving_text_${this.#productId}`, text);
    localStorage.setItem(`engraving_font_${this.#productId}`, font);

    this.#showSaved(text);
    this.#close();
  }

  #remove() {
    this.#writeHiddenInputs('', '');

    localStorage.removeItem(`engraving_text_${this.#productId}`);
    localStorage.removeItem(`engraving_font_${this.#productId}`);

    this.#summary.hidden = true;
    this.#triggerButton.hidden = false;

    this.#close();
  }

  #showSaved(text) {
    this.#summaryText.textContent = text;
    this.#triggerButton.hidden = true;
    this.#summary.hidden = false;
  }

  #getSelectedFont() {
    const checked = this.#root.querySelector('.product-engraving__font-fieldset input[type="radio"]:checked');

    return checked ? checked.value : '';
  }

  #prefillFromStorage() {
    const text = this.#textHiddenInput.value || localStorage.getItem(`engraving_text_${this.#productId}`) || '';
    const font = this.#fontHiddenInput.value || localStorage.getItem(`engraving_font_${this.#productId}`) || '';

    this.#textInput.value = text;

    if (font) {
      const match = this.#root.querySelector(`input[name^="engraving-font"][value="${CSS.escape(font)}"]`);

      if (match) {
        match.checked = true;
      }
    }
  }

  #initFromStorage() {
    const savedText = localStorage.getItem(`engraving_text_${this.#productId}`);

    if (savedText) {
      this.#writeHiddenInputs(savedText, localStorage.getItem(`engraving_font_${this.#productId}`) || '');
      this.#showSaved(savedText);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  for (const root of document.querySelectorAll('.product-engraving')) {
    new ProductEngraving(root);
  }
});
